// extracted by mini-css-extract-plugin
export default {"modal":"settingsModal_modal__Bcn9V","formControl":"settingsModal_formControl__qgp2c","modalActions":"settingsModal_modalActions__CckY0","pro":"settingsModal_pro__A5uwj"};